var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3788 19.9995C37.3788 29.5973 29.5983 37.3778 20.0005 37.3778C10.4026 37.3778 2.62207 29.5973 2.62207 19.9995C2.62207 10.4017 10.4026 2.62109 20.0005 2.62109C29.5983 2.62109 37.3788 10.4017 37.3788 19.9995Z",
    stroke: "var(--mono-1)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3603 10.8125H19.2061V23.2449H21.3603V10.8125Z",
    fill: "var(--mono-1)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.2703,
    cy: 27.3006,
    rx: 1.35135,
    ry: 1.35135,
    fill: "var(--mono-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoData);
export default __webpack_public_path__ + "static/media/icon-no-data.292f589465318f10dc8c38e0caeade35.svg";
export { ForwardRef as ReactComponent };